import React from "react";
import PropTypes from "prop-types";
import SelectLocation from "../dropdown";

Banner07.propTypes = {};

function Banner07(props) {
  return (
    <section
      className="tf-slider sl5"
      style={{
        position: "relative",
        width: "100%",
        minHeight: "60vh",
        maxHeight: "620px",
        overflow: "hidden",
      }}
    >
      {/* Background image */}
      <img
        src="https://images.unsplash.com/photo-1654452530992-43c5a7c5ab37?q=80&w=2670&auto=format&fit=crop"
        alt="UK immigration updates"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.55)",
        }}
      />

      {/* Content */}
      <div
        className="tf-container"
        style={{
          position: "relative",
          zIndex: 2,
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          padding: "24px 16px",
          color: "white",
        }}
      >
        <h2
          style={{
            fontSize: "clamp(24px, 4vw, 44px)",
            lineHeight: 1.15,
            marginBottom: "12px",
            color: "#fff",
          }}
        >
          <span>The Biggest Immigration Risk?</span>
          <br />
          <i>Not staying informed.</i>
        </h2>

        <p
          style={{
            fontSize: "clamp(19px, 2vw, 20px)",
            lineHeight: 1.6,
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          UKIC News — short for UK Immigration Council News — is committed to delivering
          the latest updates, insights, and guidance on UK immigration policies and procedures.
          Our mission is to provide reliable, authoritative, and timely information you can trust.
        </p>
      </div>
    </section>
  );
};

export default Banner07;
